
import React, { useContext } from "react";
import { motion } from "motion/react";

import { personalInfo, techStack } from "../constants";
import { ThemeContext } from "../themeProvider";

const About = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div id="about" className={darkMode === true ? "bg-gray-900" : "bg-gray-50"}>
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 md:mt-0 pt-20 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="text-center mb-16">
            <span className={`inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4 ${
              darkMode ? 'bg-blue-500/20 text-blue-400' : 'bg-blue-100 text-blue-600'
            }`}>
              Get to know me
            </span>
            <h2 className={`text-5xl md:text-6xl font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
              About Me
            </h2>
          </div>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className={`p-8 rounded-2xl ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-2xl">👨‍💻</span>
              </div>
              <h4 className="ml-4 text-3xl font-bold text-blue-500">
                A bit about me
              </h4>
            </div>
            <p
              className={`text-lg leading-relaxed text-justify ${
                darkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              {personalInfo.aboutMe}
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className={`p-8 rounded-2xl ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}
          >
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-600 rounded-lg flex items-center justify-center">
                <span className="text-2xl">🛠️</span>
              </div>
              <h4 className="ml-4 text-3xl font-bold text-blue-500">
                Tech Stack
              </h4>
            </div>
            <p
              className={`text-lg leading-relaxed text-justify ${
                darkMode ? 'text-gray-300' : 'text-gray-600'
              }`}
            >
              Construimos con tecnologías de vanguardia y marcos modernos para ofrecer soluciones escalables y de alto rendimiento en todas las plataformas. Desde el desarrollo frontend y backend hasta aplicaciones móviles y servicios en la nube, utilizamos herramientas que garantizan eficiencia, seguridad y una experiencia de usuario excepcional.
            </p>
          </motion.div>
        </div>
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="mt-16"
          >
            <h4 className={`text-2xl font-bold text-center mb-10 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Technologies I work with
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
              {techStack.map((el, index) => (
                <motion.div
                  key={el.name}
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.3, delay: index * 0.03 }}
                  viewport={{ once: true }}
                  whileHover={{ scale: 1.1, y: -5 }}
                  className={`p-4 rounded-xl flex flex-col items-center justify-center transition-all duration-300 ${
                    darkMode 
                      ? 'bg-gray-800 hover:bg-gray-700 hover:shadow-xl hover:shadow-blue-500/20' 
                      : 'bg-white hover:bg-gray-50 hover:shadow-xl hover:shadow-blue-500/20'
                  } shadow-md cursor-pointer group`}
                >
                  <img alt={el.name} src={el.link} className="w-12 h-12 object-contain mb-2 group-hover:scale-110 transition-transform" />
                  <h4 className={`text-xs font-medium text-center ${
                    darkMode ? 'text-gray-300' : 'text-gray-700'
                  }`}>{el.name}</h4>
                </motion.div>
              ))}
            </div>
          </motion.div>
      </div>
    </div>
  );
};

export default About;
